import { c as _c } from "react/compiler-runtime";
import { graphql, readFragment } from "@opensea/graphql";
import { LayoutGroup } from "motion/react";
export const ProfileHeaderLayoutGroupFragment = graphql(`
  fragment ProfileHeaderLayoutGroup on Profile {
    address
  }
`);
export function ProfileHeaderLayoutGroup(t0) {
  const $ = _c(6);
  let profile;
  let props;
  if ($[0] !== t0) {
    ({
      profile,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = profile;
    $[2] = props;
  } else {
    profile = $[1];
    props = $[2];
  }
  const {
    address
  } = readFragment(ProfileHeaderLayoutGroupFragment, profile);
  const t1 = `profile.${address}`;
  let t2;
  if ($[3] !== props || $[4] !== t1) {
    t2 = <LayoutGroup id={t1} {...props} />;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}